import { toDateInput } from '../../lib/status';

export function stateDatesChanged(
  initialStart: string | null | undefined,
  initialEnd: string | null | undefined,
  nextStart: string,
  nextEnd: string,
) {
  return toDateInput(initialStart) !== nextStart || toDateInput(initialEnd) !== nextEnd;
}

export function formatStateDateRange(start: string, end: string) {
  const format = (value: string) => {
    if (!value) return 'не задано';
    const [year, month, day] = value.split('-');
    return year && month && day ? `${day}.${month}.${year}` : value;
  };
  return `начало ${format(start)}, окончание ${format(end)}`;
}
